import React from 'react';
import Footer from "../Components/Footer";
import headshot from "../Images/Headshot.jpg";

const About = () =>{
    return(
        <div className="container">
            <div className="banner gallery-land">
                <h1 className="gallery-header">
                    Our Company Goals
                </h1>
            </div>
            <h2 className="goals">
                Founded in 2012, InterPerfect Construction specializes in the sale and installation of fenestration systems.  Located in North Jersey, the heart of the tri-state area, our goal is to provide you with the highest quality end-to-end solutions for your business.  From planning to installation, we work with you every step of the way to ensure that your needs are met and your experience exceeds all expectations.  (Im thinking about just changing this to basic information, founded in, located in, serving the tri-state areas fenestration needs for almost 10 years.)
            </h2>
            <section className="section wrap center">
                <div className="sub-content">
                    <h1 className="header">Our Mission:</h1>
                    <p className="text">
                        We aim to provide quality end to end fenestration solutions in a timely manner, we work with you every step of the way to deliver quality work you can appreciate. 
                    </p>
                </div>
                <div className="sub-content">
                    <h1 className="header"> Our Expertise:</h1>
                    <p className="text">
                        We provide quality aluminum and glass fenestration solutions. Having nearly 10 years of experience in installation; we know how to get the job done for your business.
                    </p>
                </div>
                <div className="sub-content">
                    <h1 className="header"> Our Impact:</h1>
                    <p className="text">
                        We've already worked with x businesses in the Tri-State Area and plan to keep providing our expertise for our customers.
                    </p>
                </div>
            </section>
           
            <Footer/>
        </div>
    )
}

export default About